import Vue from 'vue';

switch (true) {
  case window.location.hostname.includes('.test'):
    Vue.prototype.$api = process.env.VUE_APP_API_URL_DEV;
    break;

  case (process.env.NODE_ENV === 'development' && !process.env.CORDOVA_PLATFORM):
    Vue.prototype.$api = '';
    // Vue.prototype.$api = process.env.VUE_APP_API_URL_DEV;
    break;

  default:
    Vue.prototype.$api = process.env.VUE_APP_API_URL_PROD;
}

Vue.prototype.$is_dev = process.env.NODE_ENV === 'development' && !process.env.CORDOVA_PLATFORM;

Vue.prototype.$config = {
  style: {
    brand: {
      fontSize: process.env.VUE_APP_STYLE_BRAND_FONTSIZE,
      text: process.env.VUE_APP_STYLE_BRAND_TEXT,
      width: process.env.VUE_APP_STYLE_BRAND_WIDTH,
      height: process.env.VUE_APP_STYLE_BRAND_HEIGHT,
    },
  },

  features: {

    recaptcha: {
      enabled: process.env.VUE_APP_FEATURES_RECAPTCHA_ENABLED,
    },

    social: {
      slidePanel: {
        enabled: process.env.VUE_APP_FEATURES_SOCIAL_SLIDE_PANEL_ENABLED,
      },
      twitter: {
        url: process.env.VUE_APP_FEATURES_SOCIAL_TWITTER_URL,
        enabled: process.env.VUE_APP_FEATURES_SOCIAL_TWITTER_ENABLED,
      },
      facebook: {
        url: process.env.VUE_APP_FEATURES_SOCIAL_FACEBOOK_URL,
        enabled: process.env.VUE_APP_FEATURES_SOCIAL_FACEBOOK_ENABLED,
      },
    },
  },
};
